const filterObject = <T>(object: { [key: string]: T }, callback: (v: T, i?: number) => boolean) =>
  Object.fromEntries(Object.entries(object).filter(([, value], i) => callback(value, i)));

export default filterObject;
